import { useEffect, useRef, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import {
    getFullShortLivedDownloadURL,
    getShortLivedDownloadToken
} from '../../services/api/formApi';

const AUTO_CLOSE_SECONDS = 30;

const FileDownload = () => {
    const { fileId } = useParams();
    const [searchParams] = useSearchParams();

    const [error, setError] = useState(null);
    const [secondsLeft, setSecondsLeft] = useState(AUTO_CLOSE_SECONDS);

    const downloadUrlRef = useRef(null);

    useEffect(() => {
        let closeTimer;
        let countdownTimer;
        let cancelled = false;

        const download = async () => {
            try {
                const type = searchParams.get('type');

                if (!fileId || !type) {
                    throw new Error('Missing fileId or type');
                }

                const { fileDownloadToken } =
                    await getShortLivedDownloadToken(fileId, type);

                if (cancelled) return;

                const downloadUrl =
                    getFullShortLivedDownloadURL(fileDownloadToken);

                downloadUrlRef.current = downloadUrl;

                // Start download
                window.location.href = downloadUrl;

                countdownTimer = setInterval(() => {
                    setSecondsLeft((prev) => {
                        if (prev <= 1) {
                            clearInterval(countdownTimer);
                            return 0;
                        }

                        return prev - 1;
                    });
                }, 1000);

                closeTimer = setTimeout(() => {
                    window.close();
                }, AUTO_CLOSE_SECONDS * 1000);

            } catch (err) {
                if (cancelled) return;

                console.error('Download failed:', err);
                setError(err.message || 'Failed to download file');
            }
        };

        download();

        return () => {
            cancelled = true;
            clearTimeout(closeTimer);
            clearInterval(countdownTimer);
        };
    }, [fileId, searchParams]);

    const handleDownloadAgain = (event) => {
        event.preventDefault();

        if (downloadUrlRef.current) {
            window.location.href = downloadUrlRef.current;
        }
    };

    const handleClose = () => {
        window.close();
    };

    if (error) {
        return (
            <div
                className="min-vh-100 d-flex align-items-center justify-content-center"
                style={{ background: '#f8fafc' }}
            >
                <div className="text-center">
                    <p className="text-danger mb-3">{error}</p>

                    <button
                        type="button"
                        className="btn btn-outline-secondary"
                        onClick={handleClose}
                    >
                        Close
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div
            className="min-vh-100 d-flex align-items-center justify-content-center p-4"
            style={{ background: '#f8fafc' }}
        >
            <div
                className="text-center"
                style={{ maxWidth: '420px' }}
            >
                <p className="mb-2">
                    Your download should start automatically.
                </p>

                <p className="text-muted mb-3">
                    If it doesn't,{' '}
                    <a
                        href={downloadUrlRef.current || '#'}
                        onClick={handleDownloadAgain}
                    >
                        click here
                    </a>.
                </p>

                <button
                    type="button"
                    className="btn btn-primary btn-sm"
                    onClick={handleClose}
                >
                    Close
                </button>

                <div
                    className="text-muted mt-2"
                    style={{ fontSize: '12px' }}
                >
                    This page will close automatically in {secondsLeft}s.
                </div>
            </div>
        </div>
    );
};

export default FileDownload;